import { useCallback } from 'react';
import { useShieldPRDTelemetry } from 'App/ShieldPRD/useShieldPRDTelemetry';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { useChromeApp } from 'Workspace/ChromeApp/useChromeApp';

export const useShieldPRDTelemetryForChromeApp = () => {
	const context = useChromeApp();
	const getExtraPayload = useCallback(() => ({ isChromeApp: true }), []);
	return useShieldPRDTelemetry({
		featureFlag: FeatureFlag.WSUI10821EnableChromeAppShieldPRDTelemetry,
		context,
		getExtraPayload,
	});
};
